import React from 'react';
import PropTypes from 'prop-types';
import { CenterElement } from './styles';

const Center = ({ children }) => {
  return <CenterElement data-testid="center">{children}</CenterElement>;
};

Center.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Center;
